import { createReducer } from '../../helpers/reducers';

import { types } from '../../actions/tara';

const initialState = false;

const handleTaraSetSurveyCompleted = (state, action) => action.payload.surveyCompleted;
const setHasAnsweredSurvey = () => true;

const handlers = {
  [types.TARA_SET_SURVEY_COMPLETED]: handleTaraSetSurveyCompleted,
  [types.TARA_POST_SURVEY.SUCCESS]: setHasAnsweredSurvey,
  [types.TARA_POST_SURVEY.FAILURE]: setHasAnsweredSurvey,
};

const hasAnsweredSurvey = createReducer(initialState, handlers);

export default hasAnsweredSurvey;

export const getHasAnsweredSurvey = state => state.tara.hasAnsweredSurvey;



// WEBPACK FOOTER //
// ./src/reducers/tara/hasAnsweredSurvey.js